
import { THIRDWEB_CLIENT_ID } from '@/constants/constants'
import { createStore } from 'mipd'
import { createThirdwebClient } from 'thirdweb'

// Set up a MIPD Store, and request Providers.
export const mipdStore = createStore()
export const thirdwebClient = createThirdwebClient({ clientId: THIRDWEB_CLIENT_ID })
